import Vue from "vue";
import VueRouter from "vue-router";
import Main from "../views/Main.vue"; //导入准备好的Main组件
import Login from "../views/Login.vue"; //导入准备好的登录页组件
import Container from "../views/MicroFrontend/Container.vue";
//1.创建路由组件

Vue.use(VueRouter);

//添加路由错误捕获，忽略重复导航错误：
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};
// 2. 定义路由
const routes = [
  //主路由
  {
    path: "/",
    component: Main,
    name: "Main",
    redirect: "/home",
    children: [
      {
        path: "/micro-app*",
        name: "micro-app",
        component: Container,
      }, // 微前端主路由
    ],
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/404",
    component: () => import("@/views/404/Index.vue"),
    hidden: true,
  },
];

// 3. 创建 router 实例，然后传 `routes` 配置
const originalRoutes = [...routes];

const router = new VueRouter({
  mode: "history",
  routes: originalRoutes,
});
// 菜单没设置meta数据
// router.beforeEach((to, from, next) => {
//   if (to.meta.title) {
//     document.title = to.meta.title; // 设置页面标题
//   }
//   next();
// });
export function resetRouter() {
  const newRouter = new VueRouter({
    mode: "history",
    routes: originalRoutes, // 使用原始路由配置
  });
  // 替换matcher实现路由重置
  router.matcher = newRouter.matcher;
}

//将router实例对外进行暴露
export default router;
